import { render, staticRenderFns } from "./Input-ProjectId.vue?vue&type=template&id=8d80ebca&lang=pug"
import script from "./Input-ProjectId.vue?vue&type=script&lang=ts"
export * from "./Input-ProjectId.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports